import * as React from 'react'

import { Container, SVG } from './SVGResponsive.styles'

interface IProps {
  children: React.ReactNode
  height: number
  width: number
}

function SVGResponsive(props: IProps) {
  const { children, height, width } = props

  return (
    <Container height={height} width={width}>
      <SVG viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg">
        {children}
      </SVG>
    </Container>
  )
}

export default React.memo(SVGResponsive)
